// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../app/design/frontend/Netlogiq/farmec/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".WidgetFactory-SliderPlaceholder{-webkit-animation:var(--placeholder-animation);animation:var(--placeholder-animation);background-image:var(--placeholder-image);background-size:var(--placeholder-size);padding-bottom:40%}@media (max-width: 767px){.WidgetFactory-SliderPlaceholder{padding-bottom:100%}}\n", ""]);
// Exports
module.exports = exports;
